var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.id ? "修改门店" : "添加门店",
        visible: _vm.dialogFormVisible,
        width: "750px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.cancel,
      },
      model: {
        value: _vm.dialogFormVisible,
        callback: function ($$v) {
          _vm.dialogFormVisible = $$v
        },
        expression: "dialogFormVisible",
      },
    },
    [
      _vm.dialogFormVisible
        ? [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "100px",
                },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "门店名称：", prop: "name" } },
                  [
                    _c("el-input", {
                      staticClass: "dialogWidth",
                      attrs: { maxlength: "40", placeholder: "请输入门店名称" },
                      model: {
                        value: _vm.ruleForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "name", $$v)
                        },
                        expression: "ruleForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店简介：" } },
                  [
                    _c("el-input", {
                      staticClass: "dialogWidth",
                      attrs: {
                        maxlength: "100",
                        placeholder: "请输入门店简介",
                      },
                      model: {
                        value: _vm.ruleForm.introduction,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "introduction", $$v)
                        },
                        expression: "ruleForm.introduction",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店手机号：", prop: "phone" } },
                  [
                    _c("el-input", {
                      staticClass: "dialogWidth",
                      attrs: { placeholder: "请输入门店手机号" },
                      model: {
                        value: _vm.ruleForm.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "phone", $$v)
                        },
                        expression: "ruleForm.phone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店地址：", prop: "address" } },
                  [
                    _c("el-cascader", {
                      staticClass: "dialogWidth",
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        options: _vm.addresData,
                        props: {
                          value: "name",
                          label: "name",
                          children: "child",
                          expandTrigger: "hover",
                        },
                      },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.ruleForm.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "address", $$v)
                        },
                        expression: "ruleForm.address",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "详细地址：", prop: "detailedAddress" } },
                  [
                    _c("el-input", {
                      staticClass: "dialogWidth",
                      attrs: { placeholder: "请输入详细地址" },
                      model: {
                        value: _vm.ruleForm.detailedAddress,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "detailedAddress", $$v)
                        },
                        expression: "ruleForm.detailedAddress",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店营业：" } },
                  [
                    _c("el-time-picker", {
                      attrs: {
                        "is-range": "",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        placeholder: "请选择时间营业时间",
                        "value-format": "HH:mm:ss",
                      },
                      on: { change: _vm.onchangeTime },
                      model: {
                        value: _vm.dayTime,
                        callback: function ($$v) {
                          _vm.dayTime = $$v
                        },
                        expression: "dayTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店logo：", required: true } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.ruleForm.image
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.ruleForm.image } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "经纬度：", prop: "latitude" } },
                  [
                    _c("el-input", {
                      staticClass: "dialogWidth",
                      attrs: {
                        placeholder:
                          "请从地图坐标拾取系统复制经纬度，例如 113.123456,23.123456",
                      },
                      on: { blur: _vm.validateLatitudeFormat },
                      model: {
                        value: _vm.ruleForm.latitude,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "latitude", $$v)
                        },
                        expression: "ruleForm.latitude",
                      },
                    }),
                    _c("div", { staticClass: "tipText" }, [
                      _vm._v(
                        "格式：经度,纬度，例如 113.123456,23.123456，腾讯地图坐标拾取地址：https://lbs.qq.com/getPoint/"
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c("el-button", { on: { click: _vm.cancel } }, [
                  _vm._v("取 消"),
                ]),
                _vm.id
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["admin:system:store:update"],
                            expression: "['admin:system:store:update']",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.editForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("修改")]
                    )
                  : _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["admin:system:store:save"],
                            expression: "['admin:system:store:save']",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }